import { cellText, normalizeHeader } from '@/lib/daily-reports/cells';

export interface SpaSheetMetadata {
  spaId: string;
  spaDescription: string;
  region: string;
  revisedDate: string;
}

function labelKey(value: unknown): string {
  return normalizeHeader(value).replace(/\/.*$/, '').trim();
}

function valueFromLabeledRow(row: unknown[]): string {
  return cellText(row.slice(1).find((cell) => cellText(cell) !== ''));
}

/**
 * Read the bilingual banner on an Eaton INTO-STOCK tab. The Price List Number
 * cell wins over the sheet name — `337326 (2)` actually holds SPA 290325.
 */
export function parseSpaMetadata(
  rows: unknown[][],
  sheetName: string,
): SpaSheetMetadata {
  const found: Partial<SpaSheetMetadata> = {};
  for (const row of rows.slice(0, 12)) {
    const key = labelKey(row[0]);
    if (key.includes('PRICE LIST NUMBER'))
      found.spaId = valueFromLabeledRow(row);
    if (key.includes('DESCRIPTION'))
      found.spaDescription = valueFromLabeledRow(row);
    if (key.includes('REGION')) found.region = valueFromLabeledRow(row);
    if (key.includes('REVISED DATE'))
      found.revisedDate = valueFromLabeledRow(row);
  }
  const sheetId = /^(\d+)/.exec(sheetName)?.[1] ?? '';
  return {
    spaId: found.spaId && found.spaId !== '' ? found.spaId : sheetId,
    spaDescription: found.spaDescription ?? '',
    region: found.region ?? '',
    revisedDate: found.revisedDate ?? '',
  };
}
